"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkName = exports.checkPassword = exports.checkEmail = exports.addErrorList = void 0;
function addErrorList(target, field, message) {
    target.push({
        field: field,
        message: message
    });
}
exports.addErrorList = addErrorList;
function checkEmail(email) {
    var reg = new RegExp(/^(?!.{50})([0-9a-zA-Z_\\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/);
    if (reg.test(email)) {
        return true;
    }
    else {
        return false;
    }
}
exports.checkEmail = checkEmail;
function checkPassword(password) {
    var reg = new RegExp(/^(?=.*[0-9])(?=.*[a-zA-Z])[A-Za-z0-9\\!@#$%^&+=-_.()]{8,20}$/);
    if (reg.test(password)) {
        return true;
    }
    else {
        return false;
    }
}
exports.checkPassword = checkPassword;
function checkName(value) {
    var reg = /^.*[\\!~@#$%^&*()_+\-=`,./<>?;':"|[\]{}].*$/;
    if (reg.test(value)) {
        return true;
    }
    else {
        return false;
    }
}
exports.checkName = checkName;
